import { v4 } from "uuid";
import { useAppDispatch } from "../../common/store";
import { sendMessageLogSubmission } from "../../common/store/chat/thunks/send-message-log";
import VurbalizeEvents from "../../common/types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../utils/get-message-by-vurablize-event";
import { useContext } from "react";
import { ChatContext } from "../contexts/chat-context";
import { getChatMessages } from "../../common/store/chat/thunks/get-chat-messages";
import { customCalendarEventScheduled } from "../../common/store/chat/thunks/custom-calendar-event-scheduled";
import { ScheduleMeetingData } from "../../common/store/theme/types/schedule-meeting";

const useCustomCalendarListener = (onClose: () => void) => {
  const dispatch = useAppDispatch();
  const { sendMessageToServer } = useContext(ChatContext);

  const onEventTypeViewed = () => {
    dispatch(sendMessageLogSubmission({
      data: {
        message: 'Custom Calendar Preloaded',
        event_name: VurbalizeEvents.CUSTOM_CALENDAR_UI_EVENT,
      }
    }));
  };

  const onDateAndTimeSelected = () => {
    dispatch(sendMessageLogSubmission({
      data: {
        message: 'Custom Calendar Date and Time Selected',
        event_name: VurbalizeEvents.CUSTOM_CALENDAR_UI_EVENT,
      }
    }));
  };

  const onEventScheduled = (eventData: ScheduleMeetingData) => {
    dispatch(customCalendarEventScheduled({
      event: eventData,
      sendMessageToServer,
    }));
    onClose();
  };

  const onCloseClick = async () => {
    onClose();
    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.CUSTOM_CALENDAR_CLOSED),
        event_name: VurbalizeEvents.CUSTOM_CALENDAR_CLOSED,
        turn_id: v4(),
      }
    }));
    if (sendMessageToServer) {
      sendMessageToServer({ message: "Operator:[User closed calendar]" });
      dispatch(getChatMessages());
    }
  };

  return {
    onEventTypeViewed,
    onDateAndTimeSelected,
    onEventScheduled,
    onCloseClick,
  };
};

export default useCustomCalendarListener;
